// extracted by mini-css-extract-plugin
module.exports = {"Logo":"HSIDLogo_Logo_3Gw2t"};